import { createSlice } from '@reduxjs/toolkit'
import { FORM } from 'app/types'
import {
  DUE_DATE,
  VENDOR,
  DEPARTMENT,
  PARTICULARS,
  PROJECT,
  SUB_PROJECT,
  RELEASING_CENTER,
  SUPPORTING_DOCUMENTS,
  PROJECT_CLASSES,
  STATUS,
  GROSS_PRICE_PER_ITEM
} from 'types'

const initialState = {
  [DUE_DATE]: '',
  [VENDOR]: '',
  [DEPARTMENT]: '',
  [PARTICULARS]: '',
  [PROJECT]: '',
  [SUB_PROJECT]: '',
  [RELEASING_CENTER]: 'BDO Examiner',
  [SUPPORTING_DOCUMENTS]: {},
  [PROJECT_CLASSES]: [],
  progress: 0,
  crfId: ''
}
export const formSlice = createSlice({
  name: FORM,
  initialState: { ...initialState },
  reducers: {
    setValues: (state, action) => {
      const { fieldName, value } = action.payload
      state[fieldName] = value
      state[STATUS] = 'For Approval'
    },
    setProgress: (state, action) => {
      state.progress = action.payload
    },
    setCRF: (state, action) => {
        
      state.crfId = action.payload
    },
    clearValues: state => {
      for (const key in initialState) {
        if (key !== PROJECT_CLASSES) {
          state[key] = ''
          state[GROSS_PRICE_PER_ITEM] = 0
          state[RELEASING_CENTER] = 'BDO Examiner'
          state[STATUS] = 'For Approval'
        } else {
          state[key] = [...initialState[key]]
          state[STATUS] = 'For Approval'
        }
      }
    }
  }
})

export const { setValues, clearValues, setProgress, setCRF } = formSlice.actions
export const selectFormSlice = state => state[FORM]
export default formSlice.reducer
